import { PageHeaderType, type LayoutSpec } from '../../../../types/LayoutConfig';
import { OPTIONS_LAYOUT_ID, OPTIONS_LAYOUT_TEMPLATE_ID } from '../tokens';
import { OPTIONS_LAYOUT } from './Options';

export const OPTIONS_LAYOUT_SPEC: LayoutSpec = {
  templateId: OPTIONS_LAYOUT_TEMPLATE_ID,
  label: 'Options',
  id: OPTIONS_LAYOUT_ID,
  pageHeader: PageHeaderType.TradingDefault,
  dockViewLayout: OPTIONS_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
